<template>
  <div class="home">
    <div class="home__desktop">
      <div class="social ef__social">
        <div class="social__elem"><a href="https://www.instagram.com/eastfaq/" target="_blank"><img src="../assets/img/inst.png" alt=""></a></div>
        <div class="social__elem"><a href="https://vk.com/eastfaqband" target="_blank"><img src="../assets/img/vk.png" alt=""></a></div>
        <!-- <div class="social__elem"><a href=""><img src="./assets/img/youtube.png" alt=""></a></div> -->
      </div>
      <div class="social ef__social2">
        <div class="social__elem"><a href="https://www.youtube.com/channel/UC5ass1kMEvKrfq6xMqyUh0A" target="_blank"><img src="../assets/img/youtube.png" alt=""></a></div>
      </div>
      <div class="logo glitch" :class="{_animate: animateLogo}" data-text="East F. A. Q." ref="logo">
        <span>East F. A. Q.</span>
      </div>
    </div>
    <div class="ef-mob__socials">
      <ul>
        <li><a href="https://www.instagram.com/eastfaq/" target="_blank"><img src="../assets/img/inst.png" alt=""></a></li>
        <li><a href="https://www.youtube.com/channel/UC5ass1kMEvKrfq6xMqyUh0A" target="_blank"><img src="../assets/img/youtube.png" alt=""></a></li>
        <li><a href="https://vk.com/eastfaqband" target="_blank"><img src="../assets/img/vk.png" alt=""></a></li>
      </ul>

      <div class="mob-video" style="padding-top: 20px">
        <player />
      </div>
    </div>
  </div>
</template>

<script>

import { gsap } from 'gsap'
import Player from '../components/Player.vue'

export default {
  name: 'Home',

  components: {
    Player
  },

  data() {
    return {
      animateLogo: false,
    }
  },

  props: {
    logoPosition: {
      default: false
    }
  },

  mounted() {
    let self = this

    function onLogoAnimate() {
      setTimeout(() => {
        self.animateLogo = true
      }, 1000)
    }

    let logo = this.$refs.logo

    if (!this.logoPosition) {
      gsap.to(logo, {delay: 7, opacity: 1})
    } else {
      gsap.set(logo, {opacity: 1, yPercent: 0, onComplete: onLogoAnimate})
    }
  }
}
</script>

<style lang="scss" scoped>
  @font-face {
    font-family: Kungfont;
    src: url(../assets/fonts/Kungfont.otf);
  }

  .home {
    &__desktop {
      @media screen and (max-width: 768px) {
        display: none;
      }
    }
  }

  .ef-mob__socials {
    display: none;
    z-index: 2;
    position: relative;

    @media screen and (max-width: 768px) {
      display: block;
    }

    ul {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 320px;
      padding: 0;
      padding-top: 200px;
      margin: 0 auto;
      list-style-type: none;

      li {
        width: 100px;
        height: 47px;
        margin: 0 10px;
        font-size: 0;

        a {
          display: block;
          width: 100%;
          height: 100%;
          text-align: center;
        }
        
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }

  .logo {
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -82%);
    font-size: 100px;
    text-align: left;
    width: 547px;
    color: #fff;
    font-family: Kungfont;

    span {
      text-shadow: 5px 5px 15px rgba(0,0,0,0.7);
    }
  }

  .glitch{

    &._animate {
      
      span { 
        animation: glitch1 2.5s infinite;
      }

      &:after {
        animation: glitch2 2.5s infinite;
      }

      &:before {
        animation: glitch3 2.5s infinite;
      }
    }
  }

  .glitch:after{
    content:attr(data-text);
    position:absolute;
    left:0px;
    top:0;
    color:white;
    overflow:hidden;
  }

  .glitch:before{
    content:attr(data-text);
    position:absolute;
    left:0px;
    top:0;
    color:white;
    overflow:hidden;
  }

    @keyframes glitch1 {
    0% {
      transform: none;
      opacity: 1;
    }
    7% {
      transform: skew(-0.5deg, -0.9deg);
      opacity: 0.75;
    }
    10% {
      transform: none;
      opacity: 1;
    }
    52% {
      transform: none;
      opacity: 1;
    }
    55% {
      transform: skew(-1deg, 0.2deg);
      opacity: 0.75;
    }
    50% {
      transform: none;
      opacity: 1;
    }
    72% {
      transform: none;
      opacity: 1;
    }
    75% {
      transform: skew(0.4deg, 1deg);
      opacity: 0.75;
    }
    80% {
      transform: none;
      opacity: 1;
    }
    100% {
      transform: none;
      opacity: 1;
    }
  }

  @keyframes glitch2 {
    0% {
      transform: none;
      opacity: 0.25;
    }
    7% {
      transform: translate(-2px, -3px);
      opacity: 0.5;
    }
    10% {
      transform: none;
      opacity: 0.25;
    }
    52% {
      transform: none;
      opacity: 0.25;
    }
    55% {
      transform: translate(-5px, -1px);
      opacity: 0.5;
    }
    50% {
      transform: none;
      opacity: 0.25;
    }
    72% {
      transform: none;
      opacity: 0.25;
    }
    75% {
      transform: translate(-2px, -6px);
      opacity: 0.5;
    }
    80% {
      transform: none;
      opacity: 0.25;
    }
    100% {
      transform: none;
      opacity: 0.25;
    }
  }

  @keyframes glitch3 {
    0% {
      transform: none;
      opacity: 0.25;
    }
    7% {
      transform: translate(2px, 3px);
      opacity: 0.5;
    }
    10% {
      transform: none;
      opacity: 0.25;
    }
    52% {
      transform: none;
      opacity: 0.25;
    }
    55% {
      transform: translate(5px, 1px);
      opacity: 0.5;
    }
    50% {
      transform: none;
      opacity: 0.25;
    }
    72% {
      transform: none;
      opacity: 0.25;
    }
    75% {
      transform: translate(2px, 6px);
      opacity: 0.5;
    }
    80% {
      transform: none;
      opacity: 0.25;
    }
    100% {
      transform: none;
      opacity: 0.25;
    }
  }
</style>
